import { createElement } from 'react';

import {
  ApiBlueprint,
  SubPageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';

import { EntityProvidersClient, entityProvidersApiRef } from './api';
import { ENTITY_PROVIDERS_SETTINGS_PATH } from './paths';

const entityProvidersApi = ApiBlueprint.make({
  name: 'entity-providers',
  params: defineParams =>
    defineParams({
      api: entityProvidersApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new EntityProvidersClient({ discoveryApi, fetchApi }),
    }),
});

/**
 * `SubPageBlueprint` attaches to the page of its own plugin by default, so the
 * settings page has to be named explicitly. The tab itself is hidden from
 * non-admins by the app's page layout, keyed off the path below.
 */
const entityProvidersSettingsPage = SubPageBlueprint.make({
  name: 'entity-providers',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: ENTITY_PROVIDERS_SETTINGS_PATH,
    title: 'Entity Providers',
    loader: async () => {
      const { EntityProvidersSettingsPage } = await import(
        './components/EntityProvidersSettingsPage'
      );
      return createElement(EntityProvidersSettingsPage);
    },
  },
});

export const entityProvidersPlugin = createFrontendPlugin({
  pluginId: 'entity-providers-frontend',
  extensions: [entityProvidersApi, entityProvidersSettingsPage],
});
